<template>
  <div class="box-form box-form-products">
    <v-form>
      <v-card-text class="modal-cadastro-form">
        <v-row class="align-center">
          <v-col cols="5" md="12" class="modal-cadastro-form-col-imput">
            <!-- <v-autocomplete v-model="affiliateRef" :items="listaAllAffiliates" :disabled="!disabled" label=""
            item-text="name" item-value="id" :loading="loadingTable" /> -->
            <autoCompleteEntities :entityProps.sync="this.affiliate.affiliate.parentId" :disabled="!disabled" :inativos="false" :label="'Afiliados'" />
          </v-col>
          <v-col cols="4" class="modal-cadastro-form-col-imput">
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import variables from '@/assets/styles/helpers/_variables.scss'
import validacao from './validateReferencia'
// import { errorSnackbar } from '@/core/service/utils'

export default {
  name: 'BrModalCadastroAts',
  mixins: [validationMixin],
  directives: { mask },
  components: {
    autoCompleteEntities: () => import('./autoCompleteEntities')
  },
  props: {
    affiliate: {
      type: Object,
      default: (() => { })
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    activeModal: false,
    loading: false,
    search: '',
    loadingTable: false,
    loadingContrato: false,
    affiliateRef: ''
  }),
  watch: {
    'affiliateRef'(val) {
      this.setParentIdAffiliate(val)
    }
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('afiliadosPendentes', ['listaAllAffiliates', 'getParentIdAffiliate', 'parentIdAffiliate']),
    variables: () => variables,
    ...validacao
  },
  mounted() {
    this.getData()
    this.affiliateRef = this.affiliate.affiliate.parentId
  },
  methods: {
    ...mapActions('afiliadosPendentes', ['obterTodosAfiliados', 'setParentIdAffiliate']),

    getData() {
      this.loadingTable = true
      this.afiliado = { id: 0 }
      // this.obterTodosAfiliados()
      // .catch(err => {
      //   console.log(err)
      //     errorSnackbar(err.error)
      // })
      // .finally(() => this.loadingTable = false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/components/formularios';
@import '../../../../assets/styles/components/modal-cadastro';

.br-btn-entity-products {
  margin-top: 10px;
  min-width: auto !important;
  font-size: 0.8em !important;
}

.modal-cadastro-titulo {
  background: #6d7278;
  color: #FFF !important;
}
</style>